import { useTheme } from "@emotion/react";
import { Typography } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import React, { useRef, useState } from "react";
import SectionContainer from "../SectionContainer";

export const PARAGRAPH_TYPE = {
  key: "paragraph",
  default: {
    text: "",
  },
};

export default function Paragraph({ section, dragHandleProps }) {
  const theme = useTheme();
  const ref = useRef(null);

  const [saving, setSaving] = useState(false);

  const handleBlur = async () => {
    try {
      setSaving(true);
      await updateDoc(
        doc(db, "documents", section.documentId, "sections", section.id),
        {
          text: ref.current.innerText,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SectionContainer
      section={section}
      dragHandleProps={dragHandleProps}
      saving={saving}
    >
      <Typography
        sx={{
          color: theme.palette.text.main,
        }}
        contentEditable
        suppressContentEditableWarning={true}
        onBlur={handleBlur}
        ref={ref}
      >
        {section.text}
      </Typography>
    </SectionContainer>
  );
}
